export default __webpack_public_path__ + "static/media/icon-small-play-video.37a990c8.svg";